import { createApiCall } from 'lib/base';
import { generateEndpoint } from '@ngtrvu/use-api';

const FETCH_INVESTCORE_PORTFOLIO_STOCK_LIST_API =
  'INVESTMENT/FETCH_PORTFOLIO_STOCK_LIST_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_PORTFOLIO_STOCK_LIST_API,
  params => ({
    endpoint: generateEndpoint({
      host: `/api/admin/portfolios/stocks`,
      params: {
        // ordering: 'updated_at',
        ...params,
      },
    }),
    method: 'GET',
  })
);

export default apiCall;
